<div
  [viewportOptions]="{
    verticalTolerance: 200,
    horizontalTolerance: 10,
    shouldCheckHorizontal: false
  }"
  (visibilityChange)="onVisibilityChange($event)"
  class="search-results"
  astrobinScrollVisibility
>
  <ng-container *ngIf="!initialLoading; else loadingTemplate">
    <ng-container *ngIf="results !== null; else loadingTemplate">
      <ng-container *ngIf="results.length > 0; else noResultsTemplate">
        <div *ngFor="let post of results" (click)="openPost(post)" class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <div class="flex-grow-1">
              <h4 [innerHTML]="post.topicName | highlight: model.text?.value"></h4>
              <small>
                <span class="username">{{ post.userDisplayName }}</span>
                &middot;
                <span class="created">{{ post.created | localDate | timeago }}</span>
              </small>
            </div>
            <img *ngIf="post.userAvatar" [alt]="post.userDisplayName" [src]="post.userAvatar" />
          </div>

          <div [innerHTML]="post.bodyHtml | removeBr | highlight: model.text?.value" class="card-body"></div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <div *ngIf="loading && !initialLoading" class="loading">
    <ng-container [ngTemplateOutlet]="loadingTemplate"></ng-container>
  </div>
</div>

<ng-template #noResultsTemplate>
  <astrobin-nothing-here [withAlert]="false" [withInfoSign]="false"></astrobin-nothing-here>
</ng-template>

<ng-template #loadingTemplate>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
